import type { OutboxEntry } from '../types/outbox-entry';
import type { RecordView } from '../types/record-view';
import type { StoredRecord } from '../types/stored-record';
import { applyOutbox } from './apply-outbox';

/** Views of many records: server state plus the outbox, including records created offline. */
export function materialize(
  records: readonly StoredRecord[],
  outbox: readonly OutboxEntry[],
  actor = '',
): RecordView[] {
  const byRecord = new Map<string, OutboxEntry[]>();
  for (const entry of outbox) {
    const list = byRecord.get(entry.record_id);
    if (list) list.push(entry);
    else byRecord.set(entry.record_id, [entry]);
  }
  const views: RecordView[] = [];
  const seen = new Set<string>();
  for (const record of records) {
    seen.add(record.id);
    const view = applyOutbox(record, byRecord.get(record.id) ?? [], actor);
    if (view) views.push(view);
  }
  for (const [id, entries] of byRecord) {
    if (seen.has(id)) continue;
    const view = applyOutbox(undefined, entries, actor);
    if (view) views.push(view);
  }
  return views;
}
